/* eslint-disable */
import React, { useState, useEffect } from "react";
import { FaAngleDoubleRight, FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

const BoostArea = () => {
  const [showMeetings, setShowMeetings] = useState(false);

  useEffect(() => {
    if (!showMeetings) return;

    const existingScript = document.querySelector("script[data-hs-meetings]");

    if (!existingScript) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.setAttribute("data-hs-meetings", "true");
      s.onload = () => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      };
      document.body.appendChild(s);
    } else {
      setTimeout(() => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      }, 100);
    }
  }, [showMeetings]);

  // ===== Updated for Fund Boost =====
  const outcomes = [
    "Investor-ready structure",
    "Institutional-grade pitch assets",
    "A real investor target list",
    "Grant + equity execution plans",
    "Momentum that continues beyond the engagement",
  ];

  const forWho = [
    "Startups preparing for active fundraising",
    "Companies that already have traction or pilots",
    "Founders ready to apply for grants + equity",
    "Teams that need investor-ready assets done properly",
    "Companies tired of fragmented advisors and DIY fundraising",
  ];

  const whatMakesDifferent = [
    "Most programs stop at advice, templates, and high-level feedback",
    "Fund Boost delivers execution — done-with-you, hands-on",
    "We fix structure, refine story, build investor-grade assets, and create momentum",
    "Structured engagement (boutique-firm level outcomes)",
  ];

  const deliverablesLeft = [
    "12–24 month funding roadmap (15–20 page strategic document)",
    "Grant eligibility & execution plan (step-by-step)",
    "First-grant submission readiness plan",
    "6-month funding execution calendar",
    "Share class / SAFE / note impact analysis",
    "Cap table models (current + future scenarios)",
    "Company structuring & governance audit memo",
  ];

  const deliverablesRight = [
    "Fully redesigned, editable investor pitch deck",
    "Grant-ready executive summary (done-for-you)",
    "Business plan master template (50+ sections)",
    "SR&ED booster kit (documentation & templates)",
    "Curated investor list (50–75 investors with metadata)",
    "Lead investor shortlist (Top 5 priority targets)",
    "AI-powered investor matching report (Top 10 matches)",
    "Investor email & outreach sequences (10+ templates)",
    "Built data room (Drive / Notion / DocSend)",
    "3 recorded strategy sessions (Funding, Pitch, GTM)",
    "1 investor pitch coaching session (mock pitch)",
  ];

  const whyChoose = [
    "We act as a fractional funding CXO",
    "We combine grants + equity strategically",
    "We focus on fundability before fundraising",
    "We reduce dilution and wasted outreach",
    "We deliver assets investors actually expect",
  ];

  const notIncluded = [
    "Legal or accounting services",
    "Guaranteed funding outcomes",
    "Full grant writing (can be added separately)",
  ];

  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area  pd-bottom-90 jumpstart-page">
        <div className="container">
          <div className="row">
            {/* LEFT SIDEBAR */}
            <div className="col-lg-4 col-12 order-2 order-lg-1">
              <div className="td-sidebar service-sidebar">
              <div className="widget widget_catagory">
                                <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                  <FaArrowRight />Funding Program
                                </h5>
                                <ul className="catagory-items">
                                  <li><Link to="/funding/jumpstart" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Jumpstart</Link></li>
                                  <li><Link to="/funding/boost" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Boost</Link></li>
                                  <li><Link to="/funding/advisory" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Advisory</Link></li>
                                </ul>
              
                                <div style={{ height: '16px' }}></div>
                                <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                  <FaArrowRight />Dev Accelerator
                                </h5>
                                <ul className="catagory-items">
                                  <li><Link to="/accelerator/dev-sprint" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Sprint</Link></li>
                                  <li><Link to="/accelerator/dev-build" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Build</Link></li> 
                                  <li><Link to="/accelerator/dev-scale" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Scale</Link></li>
                                </ul>
                              </div>
                <div className="widget widget_author text-center">
                  
                  <div className="details">
                    <button
                      type="button"
                      className="btn btn-base-color border-radius-5 d-flex align-items-center"
                      onClick={() => setShowMeetings((s) => !s)}
                      style={{ backgroundColor: "#50af9b", borderColor: "#50af9b" }}
                    >
                      Book a Free Fund Boost Strategy Call +
                    </button>

                    {showMeetings && (
                      <div className="mt-3">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Download
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="/assets/pdf/Evolvelab_Fund_Boost.pdf"
                        style={{ color: "#000000" }}
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Download the Program Overview{" "}
                        <FaAngleDoubleRight
                          style={{ background: "rgba(170, 237, 222, 1)" }}
                          onMouseEnter={(e) => (e.target.style.background = "#50af9b")}
                          onMouseLeave={(e) =>
                            (e.target.style.background = "rgba(170, 237, 222, 1)")
                          }
                        />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Fund Boost Snapshot
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Fixed Fee: CAD $5,000
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Timeline: ~4 weeks
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Equity: None
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Performance: 10% grants / 5% capital
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8 order-1 order-lg-2">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  {/* HERO VIDEO */}
                  <div
                    className="thumb"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      minHeight: "400px",
                      margin: 0,
                    }}
                  >
                    <video
                      autoPlay
                      muted
                      loop
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 0,
                      }}
                    >
                      <source src="/assets/video/fund-boost.mp4" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <div
                    className="details"
                    style={{ position: "relative", zIndex: 1, padding: "50px" }}
                  >
                    {/* HERO COPY */}
                    <p className="mb-2" style={{ fontSize: '1.75rem', fontWeight: 700 }}>Evolvelab Fund Boost</p>
                    <h1>Serious About Raising Capital? We Execute With You.</h1>

                    <p className="mb-2">
                      Strategy is not enough. Execution raises capital.
                    </p>

                    <p>
                      Evolvelab Fund Boost is a hands-on Funding-as-a-Service engagement for
                      startups and growth-stage companies ready to actively pursue grants and
                      investors — with structure, assets, and momentum.
                    </p>

                    <p>
                      This is for founders who don’t want another opinion. They want investor-ready
                      materials, real outreach, and a clear execution path.
                    </p>

                    {/* OUTCOMES */}
                    <h5 className="mt-4">After Fund Boost, you will have:</h5>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {outcomes.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* WHO IT'S FOR */}
                    <h4>Who Fund Boost Is For</h4>
                    <p>Fund Boost is built for:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {forWho.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>
                      If you are serious about raising capital in the next <b>3–9 months</b>, this is for you.
                    </p>

                    {/* DIFFERENTIATOR */}
                    <h4>What Makes Fund Boost Different</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {whatMakesDifferent.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>No hype. No spray-and-pray fundraising.</b></p>

                    {/* DELIVERABLES */}
                    <h4>What You Get With Fund Boost</h4>
                    <p>This is a done-with-you execution program, not theory.</p>
                    <p><b>Core Deliverables Include:</b></p>

                    <div className="row">
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesLeft.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesRight.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* TIMELINE */}
                    <h4 id="how-it-works">How Fund Boost Works</h4>

                    <h6 className="mt-3">Weeks 1–2 – Foundation & Strategy</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Discovery & funding goals</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Corporate, cap table & governance audit</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Funding roadmap & grant execution plan</li>
                    </ul>

                    <h6>Weeks 2–3 – Investor Readiness</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Pitch deck redesign</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Investor matching & targeting</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Data room setup</li>
                    </ul>

                    <h6>Weeks 3–4 – Execution Momentum</h6>
                    <ul className="single-list-inner style-check style-check mb-4">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Go-to-market & monetization blueprint</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Outreach calendar</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Pitch coaching</li>
                    </ul>

                    <p><b>After delivery:</b> 6-month execution plan to maintain momentum.</p>

                    {/* WHY CHOOSE */}
                    <h4>Why Founders Choose Evolvelab</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {whyChoose.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>We act as your fractional funding CXO — and execute with you.</p>

                    {/* PRICING */}
                    <h4 id="pricing">Pricing & Structure</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Fixed Fee: <b>CAD $5,000</b></li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Payment: <b>50% upfront, 50% on core asset delivery</b></li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Equity Taken: <b>None</b></li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Performance : <b>10% on grants received, 5% on capital raised</b></li>
                      {/* <li><FaCheckCircle style={{ color: "#50af9b" }} /> Performance Alignment: <b>5% on capital raised</b></li> */}
                    </ul>
                    <p><b>Transparent. Aligned. Execution-focused.</b></p>

                    {/* NOT INCLUDED */}
                    <h4>What Fund Boost Is Not</h4>
                    <p>To stay focused, this engagement does not include:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {notIncluded.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* FINAL CTA */}
                    <h4>Ready to Actively Raise Capital?</h4>
                    <p>
                      If you’re serious about funding and want experienced execution at your side,
                      Fund Boost is your next step.
                    </p>

                   
                    {/* FAQ (optional, kept simple) */}
                    <h4 className="mt-5">Get in touch — have a question?</h4>
                    <p>Quick answers before you start Fund Boost.</p>

                    <div
                      className="accordion accordion-inner accordion-icon-left mt-3 mb-4"
                      id="accordionExample"
                    >
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Is this “done-for-you” or “done-with-you”?
                          </button>
                        </h3>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Fund Boost is <b>done-with-you execution</b>. We build core assets with you and
                            set up a plan that creates real momentum.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Do you guarantee funding?
                          </button>
                        </h3>
                        <div
                          id="collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            No. We don’t promise outcomes — we deliver the strategy, structure, and assets that
                            materially improve your chances.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingThree">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            What’s included in pricing?
                          </button>
                        </h3>
                        <div
                          id="collapseThree"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                           <span> Fixed fee: <b>CAD $5,000.</b> </span><br/>
                           <span> Equity: none.</span> <br/>
                          
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* “Our Best it company” section (kept to match your template) */}
                    <h4>Our Best it company</h4>
                    <p>Why founders choose Evolvelab for execution-focused fundraising support.</p>
                    <div className="row">
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li><FaCheckCircle style={{ color: "#50af9b" }} /> Fractional Funding CXO approach</li>
                          <li><FaCheckCircle style={{ color: "#50af9b" }} /> Grants + equity strategy</li>
                          <li><FaCheckCircle style={{ color: "#50af9b" }} /> Investor-grade assets</li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li><FaCheckCircle style={{ color: "#50af9b" }} /> Reduced dilution & wasted outreach</li>
                          <li><FaCheckCircle style={{ color: "#50af9b" }} /> Real execution momentum</li>
                          <li><FaCheckCircle style={{ color: "#50af9b" }} /> Clear 6-month plan post-delivery</li>
                        </ul>
                      </div>
                    </div>

                    {/* Final CTA (repeat) */}
                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <button
                        type="button"
                        className="btn btn-base-color border-radius-5"
                        style={{ backgroundColor: "#50af9b", borderColor: "#50af9b" }}
                        onClick={() => setShowMeetings((s) => !s)}
                      >
                        📅 Book a Free Fund Boost Strategy Call
                      </button>

                      <Link className="btn btn-black border-radius-5" to="/apply">
                        🚀 Apply for Fund Boost
                      </Link>
                    </div>

                    {showMeetings && (
                      <div className="mt-4">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default BoostArea;